
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateInstantTaskForm, CreateTaskScheduledForm } from '@/services/Backup/forms/CreateBackupForm';
import { BackupRepositoryInterface, BackupCreationType } from '@/services/Backup/interfaces';
import { AxiosError } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { BackupScheduleRepositoryInterface } from '../../../services/Backup/interfaces/index';
import BackupRepoPicker from "@/components/backups/BackupRepoPicker.vue";
import WebsitePicker from "@/components/website/WebsitePicker.vue";
import ServerPicker from "@/components/server/ServerPicker.vue";

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'backupRepository',
    'backupScheduleRepository',
  ],
  components: {
    ServerPicker,
    WebsitePicker,
    BackupRepoPicker,
  },
})
export default class CreateBackup extends Vue {
  public backupRepository: BackupRepositoryInterface;
  public backupScheduleRepository: BackupScheduleRepositoryInterface;

  public tab: BackupCreationType = BackupCreationType.Scheduled;

  public isLoading: boolean = false;
  public instantBackupForm: WPXFormValue<CreateInstantTaskForm> = new WPXFormValue(CreateInstantTaskForm);
  public scheduledBackupForm: WPXFormValue<CreateTaskScheduledForm> = new WPXFormValue(CreateTaskScheduledForm);

  public hasBackupRepoIdInQuery: boolean = this.$route.query.backupRepoId !== undefined;

  public async createInstantBackup(): Promise<void> {
    try {
      this.isLoading = true;
     await this.backupRepository.createBackup({
        originServerId: this.instantBackupForm.data.originServerId
      });

      this.$infoDialog.show(`Instant backup creation started!`);
    } catch (err) {
      this.onError(err);
    } finally {
      this.isLoading = false;
    }
  }

  public async createScheduledBackup(): Promise<void> {
    try {
      this.isLoading = true;
      await this.backupScheduleRepository.createBackupSchedule({
        serverId: this.scheduledBackupForm.data.serverId,
        intervalDays: Number(this.scheduledBackupForm.data.intervalDays),
        retries: Number(this.scheduledBackupForm.data.retries),
        runAtHour: Number(this.scheduledBackupForm.data.runAtHour),
        runAtMinute: Number(this.scheduledBackupForm.data.runAtMinute),
      });

      this.$infoDialog.show(`Scheduled backup creation started!`);
    } catch (err) {
       this.onError(err);
    } finally {
      this.isLoading = false;
    }
  }

  public toggleScheduledBackupTab(): void {
    this.$router.replace({ query: { ...this.$route.query, type: BackupCreationType.Scheduled } });
  }

  public toggleInstantBackupTab(): void {
    this.$router.replace({ query: { ...this.$route.query, type: BackupCreationType.Instant } });
  }

  public setTabFromParams(): void {
    const type = this.$route.query.type as BackupCreationType;
    if (type === BackupCreationType.Scheduled) {
       this.tab = BackupCreationType.Scheduled;
    } else {
      this.tab = BackupCreationType.Instant;
    }
  }

  public setupFromQueryParams(): void {
    this.setTabFromParams();
    this.setBackupRepoIdFromParams();
  }

  public setBackupRepoIdFromParams(): void {
    this.scheduledBackupForm.data.repositoryId = 0;
    this.instantBackupForm.data.originServerId = '';
  }

  public async created(): Promise<void> {
    this.setupFromQueryParams();
  }

  private onError(err: unknown): void{
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }
}
